import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import journalEntrySchema from "../../../validation/JournalEntry";
import Button from "../../Reusable/Button";
import Card from "../../Reusable/Card";
import PopupModal from "../../Reusable/Modal";
import CreateAccountPopup from "../../Transaction/CreateAccountPopup";
import JournalEntryForm from "../Form";

export default function CreateJournalEntry({
  handleCreate,
  isLoading,
  entryNoRefetch,
  numbSeriresRefetch,
  openPrintPopup,
  setOpenPrintPopup,
  isPrintLoading,
  handlePrint,
  handleCreateAccount,
  isPostLoading,
}: any) {
  const [openAccountPopup, setOpenAccountPopup] = useState(false);

  const formMethods = useForm<any>({
    resolver: yupResolver(journalEntrySchema),
    defaultValues: async () => {
      const countData = await entryNoRefetch();
      const numberSeries = await numbSeriresRefetch();
      const today = new Date().toISOString().split("T")[0];
      return {
        number_series: numberSeries?.data?.[0]?.next_series,
        entry_number: `${countData?.data?.count + 1}`,
        voucher_date: today,
        type: {
          name: "Journal Voucher",
          value: "Journal Voucher",
        },
        journal_account: [
          {
            account: null,
            credit: 0,
            debit: 0,
          },
          {
            account: null,
            credit: 0,
            debit: 0,
          },
          { account: null, credit: 0, debit: 0 },
        ],
      };
    },
  });
  const { control } = formMethods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "journal_account",
  });

  const handleAddRow = () => {
    append({
      account: "",
      debit: 0,
      credit: 0,
    });
  };

  const navigate = useNavigate();
  const handleClosePrint = async () => {
    setOpenPrintPopup(false);
    try {
      const countData = await entryNoRefetch();
      const numberSeries = await numbSeriresRefetch();
      const today = new Date().toISOString().split("T")[0];
      formMethods.reset({
        number_series: numberSeries?.data?.[0]?.next_series,
        entry_number: `${countData?.data?.count + 1}`,
        voucher_date: today,
        narration: "",
        attachment: null,
        type: {
          name: "Journal Voucher",
          value: "Journal Voucher",
        },
        journal_account: [
          {
            account: null,
            credit: 0,
            debit: 0,
          },
          {
            account: null,
            credit: 0,
            debit: 0,
          },
          { account: null, credit: 0, debit: 0 },
        ],
      });
    } catch (error) {
      console.error("Error updating voucher number:", error);
    }
  };
  const journalAccounts = formMethods.watch("journal_account");

  // useEffect(() => {
  //   if (!journalAccounts?.length) return;

  //   const totalDebit = journalAccounts.reduce(
  //     (sum, entry) => sum + Number(entry.debit || 0),
  //     0
  //   );
  //   const totalCredit = journalAccounts.reduce(
  //     (sum, entry) => sum + Number(entry.credit || 0),
  //     0
  //   );

  //   const lastIndex = journalAccounts.length - 1;
  //   const lastRow = journalAccounts[lastIndex];

  //   if (lastRow) {
  //     if (lastIndex === currentIndex && totalDebit != totalCredit) {
  //       handleAddRow();
  //     } else if (totalDebit > totalCredit) {
  //       formMethods.setValue(
  //         `journal_account.${lastIndex}.credit`,
  //         (totalDebit - (totalCredit - (lastRow.credit || 0))).toFixed(2)
  //       );
  //     } else if (totalCredit > totalDebit) {
  //       formMethods.setValue(
  //         `journal_account.${lastIndex}.debit`,
  //         (totalCredit - (totalDebit - (lastRow.debit || 0))).toFixed(2)
  //       );
  //     }
  //   }
  // }, [JSON.stringify(journalAccounts), formMethods.setValue]);

  return (
    <>
      <Card>
        <form
          onSubmit={formMethods.handleSubmit((data: any) =>
            handleCreate(data, false, formMethods.setError)
          )}
          autoComplete="off"
          className={tw` rounded-md`}
        >
          <FormProvider {...formMethods}>
            <JournalEntryForm
              setOpenAccountPopup={setOpenAccountPopup}
              handleAddRow={handleAddRow}
              append={append}
              isEdit={false}
              remove={remove}
              fields={fields}
            />
          </FormProvider>
          <div className={tw`w-full flex gap-x-4 justify-end px-4`}>
            <div className={tw`w-24 `}>
              <Button
                type="button"
                isLoading={isLoading}
                label="Save to Draft"
                onClick={formMethods.handleSubmit((data) =>
                  handleCreate(data, true, formMethods.setError)
                )}
              />
            </div>
            <div className={tw`w-24 `}>
              <Button label="Submit" isLoading={isLoading} />
            </div>
          </div>
        </form>
      </Card>
      <PopupModal
        isOpen={openAccountPopup}
        setIsOpen={setOpenAccountPopup}
        title="Create Account"
      >
        <div className={tw`max-w-2xl`}>
          <CreateAccountPopup
            handleCreateAccount={handleCreateAccount}
            isLoading={isPostLoading}
            setOpenAccountPopup={setOpenAccountPopup}
          />
        </div>
      </PopupModal>
      <PopupModal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrint}
        title={"Print"}
      >
        <form action="#" className={tw`w-[600px]`}>
          <Button
            label={"Print "}
            type="button"
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handlePrint}
            autoFocus
          />
          <Button
            type="button"
            label={"Close"}
            onClick={() => handleClosePrint()}
          />
        </form>
      </PopupModal>
    </>
  );
}

